import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import config from '../config';
import { createAuth } from '../Helpers';
import { getSlideShow } from './SlideStore';

export const reducerName = 'gridState';

export const getGridLayout = createAsyncThunk(
    'gridState/getGridLayout',
    async (id, { dispatch, getState, rejectWithValue }) => {
        try {
            const response = await axios({
                method: 'GET',
                url: `${config.server}/api/grids/${id}`,
                withCredentials: true,
                auth: createAuth(getState),
            });
            const gridLayout = response.data;
            gridLayout.cells.forEach((x) => {
                if (x.type === 2) {
                    dispatch(getSlideShow(x.slideShowId));
                }
            });
            return gridLayout;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'An error occurred');
        }
    }
);

const initialState = {
    bigView: null,
    gridLayout: null,
    ui: {
        loadingGridLayout: false,
    },
};

const gridSlice = createSlice({
    name: reducerName,
    initialState,
    reducers: {
        setBigView: (state, action) => {
            state.bigView = state.bigView === action.payload ? null : action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getGridLayout.pending, (state) => {
                state.ui.loadingGridLayout = true;
            })
            .addCase(getGridLayout.fulfilled, (state, action) => {
                state.ui.loadingGridLayout = false;
                state.gridLayout = action.payload; 
            })
            .addCase(getGridLayout.rejected, (state, action) => {
                state.ui.loadingGridLayout = false;
                state.error = action.payload || 'An error occurred'; 
            });
    },
});

export const { setBigView } = gridSlice.actions;

export default gridSlice.reducer;